$('.collection-slider').slick({
   slidesToShow: 2,
   slidesToScroll: 1,
   dots: false,
   focusOnSelect: true,
   autoplay:false,
   arrows:true,
   prevArrow:'<button type="button" class="slick-prev"></button>',
   nextArrow:'<button type="button" class="slick-next"></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1
      }
    }
   ]
//    centerMode:true,
 });

 $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.collection-slider').slick('slickGoTo', slideno - 1);
 });

